import { render, staticRenderFns } from "./FreightTableValidityPanel.vue?vue&type=template&id=5e54fca7&scoped=true"
import script from "./FreightTableValidityPanel.vue?vue&type=script&lang=js"
export * from "./FreightTableValidityPanel.vue?vue&type=script&lang=js"
import style0 from "./FreightTableValidityPanel.vue?vue&type=style&index=0&id=5e54fca7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54fca7",
  null
  
)

export default component.exports